var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-justify-center tw-h-screen"},[_c('div',{staticClass:"tw-flex tw-items-center"},[_c('sign-in-card',{staticClass:"tw-w-full",attrs:{"initialEmail":_vm.email,"buttonLocation":'body',"showFooter":false,"showForgotPassword":true},on:{"success":_vm.success}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }